export const postRatio = () => {
  const containerElement = document.getElementsByTagName("body")[0];
  const ratio = containerElement.offsetHeight / window.innerWidth;
  const location = window.location.href;

  window.parent.postMessage(
    {
      ratio:ratio,
      location:location,
    },
    "*"
  );
};

export const burstPostRatio = () => {
  postRatio();

  const intervalArray = [50, 100, 300, 500, 1000, 3500];

  intervalArray.forEach((interval) => {
    setTimeout(() => {
      postRatio();
       // console.log('burst');
    }, interval);
  });
};

export const doPostRatio = () => {
  postRatio();

  const intervalArray = [50, 100, 500];

  intervalArray.forEach((interval) => {
    setTimeout(() => {
      postRatio();
       // console.log('burst');
    }, interval);
  });
};

export const getDisplayContext = () => {

      const w = document.getElementsByTagName('body')[0].offsetWidth;
      const bigScreen = w > 440;
      const app =  inDNApp();
      const frame =  inIframe();


      return {
        
        'width' : w,
        'bigScreen' : bigScreen,
        'inApp' : app,
        'inFrame' : frame
      }



}


export function inIframe() {
  //console.log('inIframe');
  try {
      return window.self !== window.top;
  } catch (e) {
      return true;
  }
}
export function inDNApp() {
  //console.log('inDNAp');
  try {
      return !(typeof window.ReactNativeWebView === 'undefined' || window.ReactNativeWebView === null);
  } catch (e) {
      return false;
  }
}


export const isPreview = () => {


  if( inDNApp()  ){ return false } 

  if( inIframe() ){ return false; } 


  const url = new URL(window.location.href);
  const initialValue = url.searchParams.get("superPreview");

  if ( !(initialValue === '0' || initialValue === '1')  ) {return false;}

  document.getElementsByTagName("body")[0].style.overflow = "auto";

  setTimeout(() => {

        // ?id=9921&dnApp=1&dnAppVersion=6.5.5&darkMode=1

         // Om darkMode saknas: sätt default = 0
        if (!url.searchParams.has("darkMode")) {
          url.searchParams.set("darkMode", "0");
        }

        if(initialValue === "1" ){
          document.getElementsByTagName("body")[0].style.backgroundColor = "#171717";
        } else if(initialValue === "0" ) {
          document.getElementsByTagName("body")[0].style.backgroundColor = "#ffffff";
        }

        
        const next = initialValue === "1" ? "0" : "1";
        url.searchParams.set("superPreview", next);
        url.searchParams.set("darkMode", next);

        // Uppdatera URL utan reload
        history.replaceState(null, "", url.toString());

  }, 500);
  
return true;

}
